﻿export interface RoutingFlagsT {
  id: string;
  name: string;
}

/**
 * Routing flags for feature access.
 * ⚠️ These must match the C# backend - don't change one without the other!
 */
export enum RoutingFlags {
  CarrierMatchingOfferManager = '0FD21B42-87CF-42DA-AC18-CBEA9A1318EA',
  CarrierMatching = '0F114BA2-0DA1-4B49-BA35-E12D666FF5DF',
  MaxBuy = '044361E0-03B6-41BD-AD5C-F8A8D606410E',
  V4OrderDetails = '37C778F7-EF09-47FF-AB6A-5E15752E9C0D',
  V4LoadBoard = '567DD8C3-9192-4FF1-BCFF-EA403C775785',
  V4LTLQuoting = 'F585A63E-BD35-43FF-B884-380715E4EB5F',
  PricingService = '8E7EF9F6-47EC-496D-89E6-6454B6062472',
  V4ClaimsTab = 'B7CCB2A9-BD89-4F7E-AD47-63503AFF5033',
  V4CustomerDetails = '47FD2915-F7E6-4AAB-A8DC-3A2D13B073ED',
  V4CarrierSearch = '7D4E9E42-0545-44A0-ABFF-C8505E699E8F',
  V4LaneSearch = 'CEC51DF8-4714-4D7F-A588-990C342BE994',
  V4CarrierPlaylist = 'E915EB6E-25D8-40C9-916E-C5565F42AD89',
  V4CustomerCreate = '59AEC8B6-0B20-4DA2-9006-05AD973C015F',
  V4HoldsTab = '16F33DFD-8B69-48D5-B80C-3E61F97B54FF',
  V4FactoringCompanyList = '8E386189-8C76-41EC-A8AD-79BE9570782C',
  V4AdminDocuments = '33D598C3-F49E-4541-BAEE-23D4044FE520',
  V4OfficeList = '1F28F7AC-BD2E-4A27-A1AB-FA92F6A26209',
  V4DormantAccounts = 'D45BB5F2-6F41-4D60-A132-C91B55E0DA12',
  V4CarrierDetails = 'FA5D50EC-8C17-4A49-B4FF-626A78539423',
  V4NewProspect = '41B8B3AC-E534-4CF0-AF23-2A7D8A3776B7',
  V4CollectionsDashboard = 'BB775B41-0B7E-4A2D-A431-81060A3C37EA',
  V4LoadSearch = 'F234096A-F20D-46B0-BE9C-16FFB57260EC',
  V4OfficeDetails = 'B6D00726-79E7-4B06-822D-7D591F8C0995',
  V4OldLoads = 'A00C1329-2299-42E0-89DA-60FB61D86C11',
  V4Collections = 'BD94A406-90E2-4489-89D5-E5414A651CFA',
  V4RevenueSearch = 'F505DF76-7F6A-4D40-96C4-A0D7F48261AD',
  V4CollectionDetails = 'DCC432C6-4A89-474A-929D-285F913AD38E',
  V4SettlementsDashboard = 'E5AC474F-3E13-4504-9F4B-EB3518FEEE0C',
  V4RevenueDashboard = '750D57B4-C568-46A2-8C88-29AF7C5B0E4B',
  V4LoadTenders = 'D4AF4367-F60A-48B6-9D4F-50CCDC52638C',
  V4Prospects = 'AACF1771-C91F-44CC-A371-16D1A8658396',
  V4ProspectDetails = 'EAEE7551-2D3E-4D0D-9BCD-CE3BF3AC7B22',
  V4Customers = 'DA065A13-50C2-4C52-A418-3381A73DF096',
  V4UserDetails = 'BEB01BA5-4E92-4109-B809-1BC459C22F57',
  V4DormantPool = '580048B3-239E-46AD-9E1C-FC0E4AD822F6',
  V4BillingQueues = 'A30A3A78-8171-4454-933A-187485DB12F6',
  V4Settlements = '66EF8CA2-4DE0-47A0-9E0C-C3BBCECB7BA0',
  V4AdminTools = 'FC52AB71-5828-4FFB-A3C5-CA1EE9EA012C',
  V4EfsHistory = 'E7E8E88B-4E2B-4D76-AF3F-82FC6411063A',
  V4Invoicing = 'FB49599C-D150-4044-AFC3-A671BA7623EF',
  V4APCallingQueue = '4C59A978-EFA7-4FB8-8ED4-2BABFDC0F348',
  V4UploadTool = '0547BF19-F956-4331-9C13-17615DAC9C53',
  V4EdiFaq = '02DD9AD6-72CA-4B6A-9CB6-5FDB9128CB30',
  V4ReleaseNotes = '7F617651-E699-4A92-B827-A493A1BCFF1A',
  VendorManagement = '1D7B7F4B-3F28-4C71-8E28-34C033428469',
  FeatureFlagManagement = '95b192bc-b178-4472-9d1a-dbabfaa3a025',
  TrackTrace = '1BA48BCB-0EE8-4706-994D-3C17DECAACD8',
  V4CapacityFinder = '979FE97B-0594-4ED9-A500-345AC1C30A86',
  V4BolRateConInvoice = '57A2B74A-D983-4371-86D5-A87F54B4E01D',
  OptimizeLoadboard = '0DC40E2B-D8B5-46AC-ACE3-DDF92556EA31',
  CreditApp = '79961138-5A24-49C5-AC4D-3F3BB67F160C',
  CreditScoring = '796899b9-616a-4a0f-8d8c-d6a4de63c728',
}

// Optional: If you need the array format for iteration/dropdowns
export const routingFlags: RoutingFlagsT[] = Object.entries(RoutingFlags).map(
  ([name, id]) => ({ id, name }),
);
